import { createContext, useContext } from 'react';
import type { UserProfile } from '@/lib/api/user-profile';

export interface OnboardingContextType {
  isOnboardingRequired: boolean;
  isOnboardingOpen: boolean;
  isExtendedOnboardingOpen: boolean;
  userProfile: UserProfile | null;
  refetchProfile: () => Promise<unknown>;
}

export const OnboardingContext = createContext<OnboardingContextType | undefined>(undefined);

export function useOnboarding(): OnboardingContextType {
  const context = useContext(OnboardingContext);
  if (context === undefined) {
    throw new Error('useOnboarding must be used within an OnboardingProvider');
  }
  return context;
}
